import { TileIds, TileRules } from '../../../../util/tileEnums';
import { UnitedModalValue } from '../../../components/InsuranceHelpModal/modalValues';
import { InsurerCodes } from '../../../../../../../constants/insurance';

export const unitedInsightTiles = [
  {
    id: TileIds.INSURANCE_INSIGHT_NURSE_HOTLINE,
    header: 'Call Anytime',
    description: () => `24/7 access to a nurse hotline`,
    rules: [TileRules.IS_INSURANCE_UNITED, TileRules.IS_NOT_CHILD],
    modalValue: UnitedModalValue.NURSE_HOTLINE,
    sortOrder: { [InsurerCodes.UNITED_HEALTH_CARE]: 1 },
  },
  {
    id: TileIds.INSURANCE_INSIGHT_FLU_SHOT,
    header: 'Free Flu Shots',
    description: () => `Get your annual flu shot at select locations`,
    rules: [TileRules.IS_INSURANCE_UNITED, TileRules.IS_NOT_CHILD],
    modalValue: UnitedModalValue.FLU_SHOT,
    sortOrder: { [InsurerCodes.UNITED_HEALTH_CARE]: 4 },
  },
  {
    id: TileIds.INSURANCE_INSIGHT_GYM_MEMBERSHIP,
    header: 'Reward Good Health',
    description: () => `Access to the Rally Health program`,
    rules: [TileRules.IS_INSURANCE_UNITED, TileRules.IS_NOT_CHILD],
    modalValue: UnitedModalValue.GYM_MEMBERSHIP,
    sortOrder: { [InsurerCodes.UNITED_HEALTH_CARE]: 3 },
  },
  {
    id: TileIds.INSURANCE_INSIGHT_LASIK,
    header: 'See Things Clearly',
    description: () => `Up to $800 off LASIK at LasikPlus in-network provider`,
    rules: [TileRules.IS_INSURANCE_UNITED, TileRules.IS_NOT_CHILD],
    modalValue: UnitedModalValue.LASIK,
    sortOrder: { [InsurerCodes.UNITED_HEALTH_CARE]: 7 },
  },
  {
    id: TileIds.INSURANCE_INSIGHT_QUIT_FOR_LIFE,
    header: 'Stop Smoking',
    description: () => `Access to the Quit For Life program`,
    rules: [TileRules.IS_INSURANCE_UNITED, TileRules.IS_NOT_CHILD],
    modalValue: UnitedModalValue.QUIT_FOR_LIFE,
    sortOrder: { [InsurerCodes.UNITED_HEALTH_CARE]: 10 },
  },
];
